import { useNavigate, useSearchParams } from "react-router-dom";
import { DataCardItem } from "types/ui/card-item";
import { IconChevronsDown, IconChevronsUp, IconEqual } from "@tabler/icons-react";
import moment from "moment";
import { useMemo } from "react";
import { TaskStatusEnum } from "types/dict";

interface BoardCardProps {
  card: DataCardItem | undefined;
  getDeadlineColor: (card: DataCardItem) => string;
}

export function BoardCard({ card, getDeadlineColor }: BoardCardProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const taskType = searchParams.get("type");

  const isTaskBoard = useMemo(() => {
    return window.location.pathname.includes("tasks") ? true : false;
  }, [window.location.pathname]);

  return (
    <div
      className="rounded-md cursor-pointer border border-[#80A1B4] bg-white"
      onClick={() => navigate(`${taskType === "other" ? `/tasks/${card?.id}?type=${taskType}` : card?.id}`)}
    >
      {isTaskBoard && card?.status === TaskStatusEnum.REJECTED && <div className="ribbon bg-red">Доработать</div>}

      <div className="flex flex-col gap-3 p-4">
        <div className="text-base leading-5 font-medium text-[#18181B]">{card?.title}</div>
        {/* <div className="text-secondary">{card?.description}</div> */}
        <div>
          <div className="row align-items-center">
            <div className="col-auto flex items-center gap-2 px-2 py-1 text-[13px] leading-4 font-semibold text-[#52525B] rounded-xl bg-[rgba(0,67,105,0.03)]">
              {card?.assigned_to || "-"}
            </div>

            {card?.priority && (
              <div className="col-auto d-flex align-items-center">
                {card?.priority === "Средняя" ? (
                  <IconEqual size={20} className="text-warning" />
                ) : card?.priority === "Высокая" ? (
                  <IconChevronsUp size={20} className="text-danger" />
                ) : (
                  <IconChevronsDown size={20} className="text-primary" />
                )}
              </div>
            )}

            {card?.dueDate && (
              <div className={`col-auto d-flex align-items-center gap-1 rounded text-sm text-[#A3A3A3]`}>
                {moment(card?.dueDate).format("DD.MM.YYYY")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
